import { defineStore } from 'pinia'
import * as Auth from '../service/auth'
const mockUser = {
  avatar_big:
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRYnNoYVDsw_qyf1xgNNIynIMlnZWWZVbOkoh0w3duC1l9jJN3DZkfynf59gA&s',
  avatar_middle:
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRYnNoYVDsw_qyf1xgNNIynIMlnZWWZVbOkoh0w3duC1l9jJN3DZkfynf59gA&s',
  avatar_thumb:
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRYnNoYVDsw_qyf1xgNNIynIMlnZWWZVbOkoh0w3duC1l9jJN3DZkfynf59gA&s',
  avatar_url:
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRYnNoYVDsw_qyf1xgNNIynIMlnZWWZVbOkoh0w3duC1l9jJN3DZkfynf59gA&s',
  email: 'xxx',
  employee_no: 'xxx',
  en_name: '测试用户',
  enterprise_email: 'xxx',
  mobile: '+xxx',
  name: '测试用户',
  open_id: 'anonymous',
  tenant_key: 'xxx',
  union_id: 'xxx',
  user_id: 'xxx'
}
export const LoginStatus = {
  NEED_TO_LOGIN: 'NEED_TO_LOGIN',
  LOGGED_IN: 'LOGGED_IN',
  INFO_READY: 'INFO_READY'
}
export const useUserInfoStore = defineStore('userInfo', {
  state: () => ({
    userInfo: null,
    status: null
  }),
  getters: {
    isNeedToLogin: (state) => state.status === LoginStatus.NEED_TO_LOGIN,
    isLoggedIn: (state) => state.status === LoginStatus.LOGGED_IN,
    isInfoReady: (state) => state.status === LoginStatus.INFO_READY
  },
  actions: {
    init() {
      const storedData = localStorage.getItem('userInfoStore')
      if (storedData && JSON.parse(storedData).status == 'INFO_READY') {
        this.userInfo = JSON.parse(storedData).userInfo
        this.status = JSON.parse(storedData).status
        return
      }
      this.apiAuth()
    },
    async apiAuth() {
      const self = this
      //网页版登录 开发测试环境
      const hostname = window.location.hostname
      if (!window.h5sdk && (hostname == 'localhost' || hostname == 'scriptv2-dev.qfei.cn')) {
        setTimeout(() => {
          self.userInfo = mockUser
          self.status = LoginStatus.INFO_READY
        }, 300)
        // 手动保存到 localStorage
        const stateToSave = JSON.stringify({
          userInfo: mockUser,
          status: LoginStatus.INFO_READY
        })
        localStorage.setItem('userInfoStore', stateToSave)
        return
      } else if (!window.h5sdk && hostname == 'scriptv2.qfei.cn') {
        // 网页开发和测试环境未登录
        self.status = LoginStatus.NEED_TO_LOGIN
        const stateToSave = JSON.stringify({
          status: LoginStatus.NEED_TO_LOGIN
        })
        localStorage.setItem('userInfoStore', stateToSave)
        return
      } else if (window.h5sdk) {
        // 通过服务端的Route: get_appid获取app_id
        // 服务端Route: get_appid的具体内容请参阅服务端模块server.py的get_appid()函数
        // 为了安全，app_id不应对外泄露，尤其不应在前端明文书写，因此此处从服务端获取
        Auth.getAppId()
          .then(({ data }) => {
            const { app_id } = data
            // 通过error接口处理API验证失败后的回调
            window.h5sdk.error((err) => {
              throw ('h5sdk error:', JSON.stringify(err))
            })
            // 通过ready接口确认环境准备就绪后才能调用API
            window.h5sdk.ready(() => {
              // 调用JSAPI tt.requestAccess 获取 authorization code
              window.tt.requestAccess({
                appID: app_id,
                scopeList: [],
                // 获取成功后的回调
                success(res) {
                  const { code } = res
                  self.status = LoginStatus.LOGGED_IN
                  // 此处通过fetch把code传递给接入方服务端Route: callback，并获得user_info
                  // 服务端Route: callback的具体内容请参阅服务端模块server.py的callback()函数
                  Auth.login(code)
                    .then(({ data: userInfo }) => {
                      self.userInfo = userInfo
                      self.status = LoginStatus.INFO_READY
                    })
                    .catch(function (e) {
                      console.error(e)
                    })
                },
                // 获取失败后的回调
                fail(err) {
                  console.log(`getAuthCode failed, err:`, JSON.stringify(err))
                }
              })
            })
          })
          .catch(function (e) {
            // 从服务端获取app_id失败后的处理
            console.error('hehe', e)
          })
      }
    }
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'userInfoStore',
        paths: ['userInfo', 'status'],
        storage: localStorage
      }
    ]
  }
})
